import {Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NgbAccordion, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import {takeUntil} from 'rxjs/operators';
import {HolidayBookingService} from '../../holiday-booking-page/services/holiday-booking.service';
import {Observable, Subject} from 'rxjs';
import {MobileService} from '../../../../shared/services/mobile.service';
import { IHolidayDetailSolution } from '../../holiday-detail-page/interfaces/iholiday-detail-solution';
import { HolidayPrefetchService } from 'src/app/modules/shared/services/holiday-prefetch.service';
import { IPrefetchDateParams } from 'src/app/modules/shared/interfaces/iprefetch-date-params';

@Component({
  selector: 'holiday-detailgeneric-page-date',
  templateUrl: './holiday-detailgeneric-page-date.component.html',
  styleUrls: ['./holiday-detailgeneric-page-date.component.scss']
})
export class HolidayDetailgenericPageDateComponent implements OnInit, OnChanges, OnDestroy {

  @Input() allAvailableDates: Date[];
  @Input() searchSolution: IHolidayDetailSolution;

  @ViewChild('a') accordion: NgbAccordion;

  private unsubscribe$ = new Subject();
  isMobile$: Observable<boolean>;

  public innerSelectedDate: NgbDateStruct;
  public minDate: NgbDateStruct;
  public maxDate: NgbDateStruct;
  public innerSelectedDateAsJsDate: Date;
  public accomodationId;

  constructor(
    private _holidayBookingService: HolidayBookingService,
    private _mobileService: MobileService,
    private _holidayPrefetchService: HolidayPrefetchService
  ) {
  }

  ngOnInit(): void {
    if(this.searchSolution){
      this.innerSelectedDateAsJsDate = this.searchSolution.dateFrom;
      this.innerSelectedDate = {year: this.searchSolution.dateFrom.getFullYear(), month: this.searchSolution.dateFrom.getMonth() + 1, day: this.searchSolution.dateFrom.getDate()}
      this.onNewDepartureDateConfirmed();

      const urlParams = window.location.href.split('dettaglio/')[1].split('/');
      this.accomodationId = urlParams[0];


      let prefetchDateParams = {} as IPrefetchDateParams;
      prefetchDateParams.accommodations = [this.accomodationId];
      this._holidayPrefetchService.prefetchDate(prefetchDateParams).toPromise()
      .then((dates: string[]) => {
        if (!dates?.length) {
          throw new Error('No available dates!');
        }
        if (!this.searchSolution.parentId || this.searchSolution.parentId === '') {
          this.allAvailableDates = [...new Set(dates)]
            ?.map((stringDate: string) => {
              return dayjs(stringDate, 'YYYY-MM-DD').isValid() ?
                dayjs(stringDate, 'YYYY-MM-DD').toDate() :
                null;
            })
            ?.filter((validDate: Date) => validDate);
        } else {
          prefetchDateParams.accommodations = [Number(this.searchSolution.parentId)];
          this._holidayPrefetchService.prefetchDate(prefetchDateParams).toPromise()
            .then((dates: string[]) => {
              if (!dates?.length) {
                throw new Error('No available dates!');
              }
              let matchDates = [];
              this.allAvailableDates.forEach(date => {
                dates.forEach((stringDate) => {
                  const date1 = new Date(stringDate);
                  date1.setHours(0, 0, 0, 0);
                  const date2 = new Date(date);
                  date2.setHours(0, 0, 0, 0);
                  if (date1.getTime() === date2.getTime()) {
                    matchDates.push(stringDate);
                  }
                })
              })
              this.allAvailableDates = [...new Set(matchDates)]
                ?.map((stringDate: string) => {
                  return dayjs(stringDate, 'YYYY-MM-DD').isValid() ?
                    dayjs(stringDate, 'YYYY-MM-DD').toDate() :
                    null;
                })
                ?.filter((validDate: Date) => validDate);
            })
        }
      })
      .catch((err: Error) => {
        console.warn(err);
      });
    }

    this.isMobile$ = this._mobileService.isMobile();

    this._holidayBookingService.departureDateAccordionTrigger$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        document.querySelector('#dateSectionWrapper')?.scrollIntoView({
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.accordion.expand('departure-date-panel');
        }, 500);
      });

    this._holidayBookingService.selectedDepartureDate$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((departureDate: Date) => {
        this.innerSelectedDateAsJsDate = departureDate;
        this.innerSelectedDate = departureDate ?
          this.jsDateToNgbDate(departureDate) :
          null;
      });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allAvailableDates && this.allAvailableDates?.length) {
      this.minDate = this.jsDateToNgbDate(this.allAvailableDates[0]);
      this.maxDate = this.jsDateToNgbDate(this.allAvailableDates[this.allAvailableDates.length - 1]);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private isDateUnvailable = (dateToCheck: NgbDateStruct): boolean => {
    return !this.allAvailableDates.some((dateAvailable: Date) => {
      return dayjs(dateAvailable).isSame(this.ngbDateToJsDate(dateToCheck));
    });
  };

  private ngbDateToJsDate(ngbDate: NgbDateStruct): Date {
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  private jsDateToNgbDate(jsDate: Date): NgbDateStruct {
    return {
      year: jsDate.getFullYear(),
      month: jsDate.getMonth() + 1,
      day: jsDate.getDate()
    };
  }

  public onNewDepartureDateConfirmed(): void {
    const selectedDate = this.ngbDateToJsDate(this.innerSelectedDate);
    this._holidayBookingService.setData('selectedSolution', null);
    this._holidayBookingService.setData('selectedDepartureDate', selectedDate);
    if(this.accordion) this.accordion.collapse('departure-date-panel');
  }

}
